import { Component, OnInit, ViewChild, QueryList, ViewChildren, ElementRef, Output, EventEmitter, HostListener } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ModalComponent } from 'ng2-bs3-modal/ng2-bs3-modal';
import { DBOperation } from '../../../shared/enum';

import { NgSelectComponent } from '@ng-select/ng-select';
import { Repository } from '../../../services/repository'


import 'jquery'
import 'bootstrap' 

import {
  Lists_nguonkinhphi, Lists_nhacungcap, Lists_chuong, Lists_loaikhoan, Lists_tieumuc, Lists_canbo, Lists_caphat, Lists_nghiepvu, Lists_nganhang, Lists_hoatdong, Lists_cmmt, Lists_mathongke,
  tiens_rutdutoan_ctuck, tiens_rutdutoan_ck, Lists_khachhang, Lists_nhommucchi, Lists_taisancodinh, Lists_congcudungcu, Lists_vattuhanghoa, Lists_doituongtaphop2, Lists_doituongtaphop
  , Lists_doituong, Lists_donvitinh, Lists_khohang, Lists_phongban, tonghops_chungtuketchuyen, Lists_nhiemvuchi
} from '../../../routes/menu'
import { load } from '@telerik/kendo-intl';


const swal = require('sweetalert');
@Component({
  selector: 'app-ketoan-chungtukhacedit',
  templateUrl: './chungtukhacedit.component.html',
  styleUrls: ['./chungtukhacedit.component.scss'],
  providers: [ListService, Repository]
})


export class chungtukhaceditComponent implements OnInit {
  inputloaithues: any;
  hienthikekhai: boolean = false;
  inputloaitiens: any;
  NgoaiTe: boolean = false;
  thaydoi: boolean = false;
  dorong: any = '250';
  fixcot: number = 0;
  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  quyen_themdoituong: boolean = false;
  quyen_themnguon: boolean = false;
  quyen_themchuong: boolean = false;
  quyen_themkhoan: boolean = false;
  quyen_themtieumuc: boolean = false;
  quyen_themcapphat: boolean = false;
  quyen_themnghiepvu: boolean = false;
  quyen_themnganhang: boolean = false;
  quyen_themctmt: boolean = false;
  quyen_themhoatdong: boolean = false;
  quyen_themthongke: boolean = false;
  quyen_themnhommuchi: boolean = false;
  quyen_themvattuhanghoa: boolean = false;
  quyen_themtaisan: boolean = false;
  quyen_themcongcu: boolean = false;

  quyen_themtaphop: boolean = false;
  quyen_themtaphop2: boolean = false;
  inputtaphops: any;
  inputtaphops2: any;
  taphopid: string = Lists_doituongtaphop.id;
  taphopid2: string = Lists_doituongtaphop2.id;
  inputtaisans: any;

  msg: string;
  @ViewChild('modal', { static: false }) modal: ModalComponent;
  @ViewChild('mdDoiTuongChung', { static: false }) mdDoiTuongChung: ModalComponent;
  @ViewChild('mdDoiTuongNH', { static: false }) mdDoiTuongNH: ModalComponent;
  @ViewChild('mdCanBo', { static: false }) mdCanBo: ModalComponent;
  @ViewChild('mdKhachHang', { static: false }) mdKhachhang: ModalComponent;
  @ViewChild('mdLuaChon', { static: false }) mdLuaChon: ModalComponent;
  @ViewChild('slKhachHang', { static: false }) slKhachHang: NgSelectComponent;
  @ViewChild('slTaiKhoanNo', { static: false }) slTaiKhoanNo: NgSelectComponent;
  @ViewChildren(NgSelectComponent) slcombo: QueryList<NgSelectComponent>
  @ViewChild('dteChung', { static: false }) doituongchungedit: any;
  @ViewChild('dtenganhang', { static: false }) nganhangedit: any;
  @ViewChild('dteCanBo', { static: false }) canboedit: any;
  @ViewChild('dteKhachHang', { static: false }) khachhangedit: any;
  @ViewChild("diengiaitxt", { static: false }) diengiaitxt: ElementRef;

  @ViewChild('mdTaiSan', { static: false }) mdTaiSan: ModalComponent;
  @ViewChild('dtetaisan', { static: false }) taisanedit: any;

  @ViewChild('mdChonDoiTuongChung', { static: false }) mdChonDoiTuongChung: ModalComponent;
  @ViewChild('dtechondoituongchungedit', { static: false }) dtechondoituongchungedit: any;


  datas: Idata[];
  data: Idata;
  indLoading: boolean = false;
  dataFrm: FormGroup;
  dbops: DBOperation;
  modalTitle: string;
  modalBtnTitle: string;
  inputtaikhoans: any;
  inputkhachhangs: any;
  inputnguonkinhphis: any;
  inputdoituongs: any;
  inputchuongs: any;
  inputcaphats: any;
  inputnghiepvus: any;
  inputnganhangs: any;
  inputhoatdongs: any;
  inputcmmts: any;
  inputthongkes: any;
  inputloaikhoans: any;
  inputtieumucs: any;
  inputlienquans: any;
  themdoituongtrenluoi: number;
  public ngaychungtu: Date = new Date();
  public ngayghiso: Date = new Date();
  taikhoanno: any = null;
  tendoituong: any = null;
  tabselected: number = 1;
  public mask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  @Output() save: EventEmitter<any> = new EventEmitter();
  isHidden: number = 0;
  public loading = true;
  primaryColour: string = '#5d9cec';
  secondaryColour: string = '#ff902b';
  //----------tham số các nhóm cột------------------
  nhomnguonid: string = Lists_nguonkinhphi.id;
  nhomchuongid: string = Lists_chuong.id;
  nhomloaikhoanid: string = Lists_loaikhoan.id;
  nhomtieumucid: string = Lists_tieumuc.id;
  hinhthuccapphatid: string = Lists_caphat.id;
  nghiepvuid: string = Lists_nghiepvu.id;
  nganhangid: string = Lists_nganhang.id;
  hoatdongid: string = Lists_hoatdong.id;
  cmmtid: string = Lists_cmmt.id;
  mathongke: string = Lists_mathongke.id;
  doituongid: string = "532A61EA-D765-844B-8CBF-E610B209E332";
  taisanid: string = Lists_taisancodinh.id;
  //-----------------------------------------------------

  chungtuSelect: any = {
    Id: null, Don_Vi_Id: null, Ho_Ten: null, Doi_Tuong_Id: null,
    Phan_He_Id: null, Dien_Giai: null, Dia_Chi: null, Ngay_Chung_Tu: null, Ngay_Ghi_So_S: null, Ngay_Chung_Tu_S: null, Ma_Chung_Tu: null, Ngay_Ghi_So: null, Hach_Toan: null, Lien_Quan_Id: null, Tai_Khoan_No_Id: '',
    SoQD: null, NgayQD: null, So_Giay_Rut_Du_Toan: null, Ngay_Giay_Rut_Du_Toan: null, Loai_Nhan_Du_Toan: null, Loai_Phan_Bo_Du_Toan: null, Nghiep_Vu_Rut_Du_Toan: null,
    CTMT_Id: null, Loai_Tien_Id: null, Tai_Khoan_Ngan_Hang1_Id: null, Tai_Khoan_Ngan_Hang2_Id: null,
    ChiTiets: [], DongThois: [], CapNhatLaiGiayRut: null, HoaDons: []
  };
  idFocus: string = '00000000-0000-0000-0000-000000000000';

  tongtien2: number = 0;
  public changeST2(drow: any) {
    this.tongtien2 = 0;
    this.chungtuSelect.DongThois.forEach(
      (item) => {
        this.tongtien2 = this.tongtien2 + (item.So_Tien === null ? 0 : item.So_Tien);
      }
    );
  }

  public ngxCurrencyOptions = {
    prefix: '',
    thousands: '.',
    decimal: ',',
    precision: 0,
    allowNegative: false
  };
  public ngxAmOptions = {
    prefix: '',
    thousands: '.',
    decimal: ',',
    precision: 0,
    allowNegative: true
  };
  onLoaiTienChange($event) {
    const defaultId = "55DBA7D5-A26A-4998-BAC3-4701678E0D11";
    this.NgoaiTe = $event && $event.Id.toUpperCase() !== defaultId;
  }
  public changeThueSuat(drow: any) {
    if (drow.Tien_Hang != null && drow.Thue_Suat != null)
      drow.Tien_Thue = drow.Tien_Hang * (drow.Thue_Suat / 100.00);
  }
  public changeLoaiThue(event: any, row: any, index: number) {
    let roW1;
    if (typeof event === "undefined") {

    }
    else {
      //this.chungtuSelect.HoaDons[index].Tai_Khoan_No_Id = event;
      this.chungtuSelect.HoaDons[index].Loai_Thue_Id = event;
      this.repo.postRequest("api/chungtu/thaydoiloaithue", this.chungtuSelect)
        .subscribe(response => {
          if (response.Status === "OK") {
            this.chungtuSelect.HoaDons[index].Thue_Suat = response.Data.Thue_Suat;
            this.chungtuSelect.HoaDons[index].Tien_Hang = response.Data.Tien_Hang;
            this.chungtuSelect.HoaDons[index].Tien_Thue = response.Data.Tien_Thue;
            this.chungtuSelect.HoaDons[index].Doi_Tuong = response.Data.Doi_Tuong;
            this.chungtuSelect.HoaDons[index].Ma_So_Thue = response.Data.Ma_So_Thue;
            this.chungtuSelect.HoaDons[index].Dien_Giai = response.Data.Dien_Giai;
            this.chungtuSelect.HoaDons[index].Ngay_Hoa_Don = new Date(response.Data.Ngay_Hoa_Don);
          }
        });
    }

  }

  donviid: string = null;
  namketoan: number;
  username: string = null;
  //-----------------cac hàm khởi tạo dữ liệu ban đầu
    constructor(private repo: Repository) {

     
     
  }
  @HostListener('document:keydown', ['$event'])
  public handleKeyboardEvent(event: KeyboardEvent): void {
    if ((event.altKey || event.metaKey) && event.keyCode == 49) {
      this.tabselected = 1;

      setTimeout(() => {
        this.setComboFocus(0, 1, 1);
      }, 500);
    }
    if ((event.altKey || event.metaKey) && event.keyCode == 50) {
      this.tabselected = 2;
      setTimeout(() => {
        this.setComboFocus(0, 1, 2);
      }, 500);
    }
    if ((event.altKey || event.metaKey) && event.keyCode == 51) {
      this.tabselected = 3;
      setTimeout(() => {
        this.setComboFocus(0, 1, 3);
      }, 500);
    }
    event.stopPropagation();

  }
  phanheid: string = null;
  public innerHeight: any;
  loaiketchuyen: any = null;
  hachtoandongthois: any = [];
  chitietdongthois: any = [];
  lachungtuketchuyen: boolean = false;

  //id--ichung tu; loai: đánh dấu trường hợp copy (1: copy, 0: ko)
  loadDataInit(id: string, loai: number, pheid: string, ctu: any) {
    if (id == "0" || id == "1" || id == "2") {
      this.loaiketchuyen = id;
      id = null;
    }

    if (pheid == tonghops_chungtuketchuyen.id)
      this.lachungtuketchuyen = true;

    this.chitietdongthois = [];
    this.innerHeight = window.innerHeight - 250;
      this.ngaychungtu = new Date();
      this.ngayghiso = new Date();
    this.tabselected = 1;
    this.phanheid = pheid;
    this.thaydoi = false;
    //----------------------lây thông tin ban đầu
    
    var crru = JSON.parse(localStorage.getItem('currentUser'));
    if (crru != null) {
      this.donviid = crru.id_don_vi;
      this.namketoan = crru.nam_ke_toan;
      this.username = crru.user_name;
      var giatri = crru.ds_quyen.filter(name => name.id === this.phanheid.toLowerCase());
      if (giatri != null && giatri.length > 0) {
        if (giatri[0].them == true)
          this.quyen_them = true;
        else
          this.quyen_them = false;
        if (giatri[0].sua == true)
          this.quyen_sua = true;
        else
          this.quyen_sua = false;
        if (giatri[0].xoa == true)
          this.quyen_xoa = true;
        else
          this.quyen_xoa = false;
      }
      // gán quyền thêm đối tượng
      var giatri1 = crru.ds_quyen.filter(name => name.id === ('532A61EA-D765-844B-8CBF-E610B209E332').toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themdoituong = true;
        else
          this.quyen_themdoituong = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_nguonkinhphi.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themnguon = true;
        else
          this.quyen_themnguon = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_chuong.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themchuong = true;
        else
          this.quyen_themchuong = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_loaikhoan.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themkhoan = true;
        else
          this.quyen_themkhoan = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_tieumuc.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themtieumuc = true;
        else
          this.quyen_themtieumuc = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_caphat.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themcapphat = true;
        else
          this.quyen_themcapphat = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_nghiepvu.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themnghiepvu = true;
        else
          this.quyen_themnghiepvu = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_nganhang.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themnganhang = true;
        else
          this.quyen_themnganhang = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_cmmt.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themctmt = true;
        else
          this.quyen_themctmt = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_hoatdong.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themhoatdong = true;
        else
          this.quyen_themhoatdong = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_mathongke.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themthongke = true;
        else
          this.quyen_themthongke = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_nhommucchi.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themnhommuchi = true;
        else
          this.quyen_themnhommuchi = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_vattuhanghoa.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themvattuhanghoa = true;
        else
          this.quyen_themvattuhanghoa = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_taisancodinh.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themtaisan = true;
        else
          this.quyen_themtaisan = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_congcudungcu.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themcongcu = true;
        else
          this.quyen_themcongcu = false;
      }

      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_doituongtaphop.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themtaphop = true;
        else
          this.quyen_themtaphop = false;
      }
      giatri1 = crru.ds_quyen.filter(name => name.id === Lists_doituongtaphop2.id.toLowerCase());
      if (giatri1 != null && giatri1.length > 0) {
        if (giatri1[0].them == true)
          this.quyen_themtaphop2 = true;
        else
          this.quyen_themtaphop2 = false;
      }
    }
    //-----------------------------------------------
    //---------kiểm tra có phải phân hệ rút tiền mặt từ phiếu rút dự toán
    if (this.phanheid.toLowerCase() === tiens_rutdutoan_ctuck.id.toLowerCase()) {
      this.isHidden = 1;
      if (id === null)
        this.isHidden = 2;
      this.repo.postRequest('api/chungtu/get_chungtulienquan', { id: this.donviid, chuoi: tiens_rutdutoan_ck.id, status: this.namketoan })
        .subscribe(response => {
          console.log(response);
          this.inputlienquans = response;
        });
    }
    //--------------------------------------------------------------------
      this.chungtuSelect = {
        Id: null, Don_Vi_Id: this.donviid, Ho_Ten: null, Doi_Tuong_Id: null,
        Phan_He_Id: this.phanheid, Dien_Giai: null, Dia_Chi: null, Ngay_Chung_Tu: null, Ngay_Ghi_So_S: null, Ngay_Chung_Tu_S: null, Ma_Chung_Tu: null, Ngay_Ghi_So: null, Hach_Toan: null, Lien_Quan_Id: null, Tai_Khoan_No_Id: '',
        SoQD: null, NgayQD: null, So_Giay_Rut_Du_Toan: null, Ngay_Giay_Rut_Du_Toan: null, Loai_Nhan_Du_Toan: null, Loai_Phan_Bo_Du_Toan: null, Nghiep_Vu_Rut_Du_Toan: null,
        CTMT_Id: null, Loai_Tien_Id: null, Tai_Khoan_Ngan_Hang1_Id: null, Tai_Khoan_Ngan_Hang2_Id: null,
        ChiTiets: [], DongThois: [], CapNhatLaiGiayRut: null, HoaDons: []
      };

    if (id === null) {
      if (this.loaiketchuyen == null) {
        if (ctu === null) {
          this.repo.getRequest('api/donvicauhinh/thietlapngamdinh/' + this.donviid)
            .subscribe(response => {
              console.log(response);
              this.AddRowNew(this.chungtuSelect.ChiTiets);
              this.chungtuSelect.ChiTiets[0].Nguon_Id = response.Nguon_Id;
              this.chungtuSelect.ChiTiets[0].Loai_Khoan_Id = response.Loai_Khoan_Id;
              this.chungtuSelect.ChiTiets[0].Tieu_Muc_Id = response.Tieu_Muc_Id;
              this.chungtuSelect.ChiTiets[0].Hinh_Thuc_Cap_Phat_Id = response.Hinh_Thuc_Cap_Phat_Id;
              this.chungtuSelect.ChiTiets[0].Nghiep_Vu_Id = response.Nghiep_Vu_Id;
              this.chungtuSelect.ChiTiets[0].Chuong_Id = response.Chuong_Id;
            });
        }
        else {
          this.chungtuSelect = ctu;
          if (this.chungtuSelect.Ngay_Ghi_So != null) {
            this.ngaychungtu = new Date(this.chungtuSelect.Ngay_Ghi_So);
            this.ngayghiso = new Date(this.chungtuSelect.Ngay_Ghi_So);
          }
          //----------gán mặc định--------------------------

        }
        if (this.chungtuSelect.Loai_Tien_Id!==null && this.chungtuSelect.Loai_Tien_Id.toUpperCase() !== "55DBA7D5-A26A-4998-BAC3-4701678E0D11")
          this.NgoaiTe = true;
        else
          this.NgoaiTe = false;

        this.hienthikekhai = false;

        if (ctu === null || ctu.Ma_Lien_Quan === null || ctu.Ma_Lien_Quan === "") {
          if (ctu !== null) {
            this.chungtuSelect.Ma_Lien_Quan = ctu.Ma_Chung_Tu;
            this.chungtuSelect.Lien_Quan_Id = ctu.Id;
            this.isHidden = 3;
          }
          this.chungtuSelect.Id = null;
          //{ id: this.donviid, chuoi: tiens_phieuthu.id, status: '2019' }
          if (this.chungtuSelect.Ma_Lien_Quan != null && this.chungtuSelect.Ma_Lien_Quan != "") {
            this.repo.getRequest('api/donvicauhinh/thietlapngamdinh/' + this.donviid)
              .subscribe(response => {
                // chỉ tạo mã chứng từ mới khi tham số hệ thống cài đặt LaySoPhieuTuChungTuGoc=true
                if (response.LaySoPhieuTuChungTuGoc === false || response.LaySoPhieuTuChungTuGoc == null) {
                  this.repo.postRequest("api/chungtu/get_taomachungtuv2/", { id: this.donviid, chuoi: this.phanheid, status: this.namketoan })
                    .subscribe(response1 => {
                      //console.log(response[0].Column1);
                      if (response1 != null)
                        this.chungtuSelect.Ma_Chung_Tu = response1[0].Column1;

                      this.loading = false;
                    });
                }
                else
                  this.loading = false;
              });
          } else {
            this.repo.postRequest("api/chungtu/get_taomachungtuv2/", { id: this.donviid, chuoi: this.phanheid, status: this.namketoan })
              .subscribe(response => {
                //console.log(response[0].Column1);
                if (response != null)
                  this.chungtuSelect.Ma_Chung_Tu = response[0].Column1;

                this.loading = false;
              });
          }

        }
        else //trường hợp sửa lại chứng từ phiếu thu từ phiếu rút tiền dự toán
        {
          this.isHidden = 3;
          var m_lienquan = this.chungtuSelect.Ma_Lien_Quan;
          var i_lienquan = this.chungtuSelect.Lien_Quan_Id;
          this.chungtuSelect.Ma_Lien_Quan = ctu.Ma_Chung_Tu;
          this.chungtuSelect.Lien_Quan_Id = ctu.Id;

          this.chungtuSelect.Ma_Chung_Tu = m_lienquan;
          this.chungtuSelect.Id = i_lienquan;
          this.loading = false;
        }
        if (this.lachungtuketchuyen == true)
          this.fn_fixcot2();
        else
        this.fn_fixcot();
      }
      else {
        if (this.loading == false)
          $('#loading').show();
        this.repo.postRequest("api/chungtu/get_ketchuyen/", { DonViId: this.donviid, PhanHeId: this.phanheid, NamKeToan: this.namketoan, Loai: this.loaiketchuyen, UserName: crru.user_name })
          .subscribe(response => {
            console.log(response);
            this.chungtuSelect = response;
            this.chungtuSelect.Phan_He_Id = this.phanheid;
            this.chungtuSelect.Don_Vi_Id = this.donviid;
            this.ngaychungtu = new Date();
            this.ngayghiso = new Date();
            if (this.loading == false)
              $('#loading').hide();
            this.loading = false;
            if (this.lachungtuketchuyen == true)
              this.fn_fixcot2();
            else
            this.fn_fixcot();
          });
      }
    }
    else {
      this.repo.postRequest("api/chungtu/get_thongtinchungtuv2/", { id: id, status: loai })
        .subscribe(response => {
          console.log(response);
          this.chungtuSelect = response;
          if (this.chungtuSelect.Loai_Tien_Id!==null && this.chungtuSelect.Loai_Tien_Id.toUpperCase() !== "55DBA7D5-A26A-4998-BAC3-4701678E0D11")
            this.NgoaiTe = true;
          else
            this.NgoaiTe = false;
          this.tongtien2 = 0;

          this.repo.postRequest("api/chungtu/hienthikekhaithue", this.chungtuSelect)
            .subscribe(response => {
              if (response == "1" || response == "2") {
                this.hienthikekhai = true;
              }
              else {
                this.hienthikekhai = false;
              }
            });


          this.chungtuSelect.DongThois.forEach(
            (item) => {
              this.tongtien2 = this.tongtien2 + (item.So_Tien === null ? 0 : item.So_Tien);
            }
          );

          if (this.chungtuSelect.Ma_Lien_Quan !== null && this.chungtuSelect.Ma_Lien_Quan !== "") {
            this.isHidden = 3;
          }
          else
            this.isHidden = 0;

          if (loai === 1) {
            let idcopy = this.chungtuSelect.Id;
            this.chungtuSelect.Id = null;
            this.chungtuSelect.Ma_Lien_Quan = null;
            this.chungtuSelect.Lien_Quan_Id = null;
            this.chungtuSelect.Giao_Dich_Id = null;
            this.repo.postRequest("api/chungtu/get_taomachungtuv2/", { id: this.donviid, chuoi: this.phanheid, status: this.namketoan, Chuoi4: idcopy })
              .subscribe(response => {
                //console.log(response[0].Column1);
                if (response != null)
                  this.chungtuSelect.Ma_Chung_Tu = response[0].Column1;

                this.loading = false;
              });
          }
          else
            this.loading = false;
          if (loai === 1) {
            this.ngaychungtu = new Date();
            this.ngayghiso = new Date();
          }
          else {
            this.ngaychungtu = new Date(this.chungtuSelect.Ngay_Chung_Tu);
            this.ngayghiso = new Date(this.chungtuSelect.Ngay_Ghi_So);
          }
          if (this.lachungtuketchuyen == true)
            this.fn_fixcot2();
          else
          this.fn_fixcot();

        });
      
    }


      setTimeout(() => {        
        this.slKhachHang.focus();
    }, 1000);
   // this.fixcot = 0;
    

  }
  fn_fixcot() {
    console.log("độ dài: ");
    console.log(this.chungtuSelect.ChiTiets.length);


    if (this.chungtuSelect.ChiTiets.length <= 50) {
      (window as any).timer01(this.fixcot, 1500,'fixTablechungtukhac_01');
      (window as any).timer01(this.fixcot, 1500, 'fixTablechungtukhac_02');
      (window as any).timer01(this.fixcot, 1500, 'fixTablechungtukhac_03');
    }
  }
  fn_fixcot2() {
   
    //if (this.chungtuSelect.ChiTiets.length <= 200) {
      (window as any).timer01(this.fixcot, 1500, 'fixTablechungtukhac_01');
      (window as any).timer01(this.fixcot, 1500, 'fixTablechungtukhac_02');
      (window as any).timer01(this.fixcot, 1500, 'fixTablechungtukhac_03');
    //}
  }
 
  ngOnInit(): void {
    var crru = JSON.parse(localStorage.getItem('currentUser'));
    if (crru != null) {
      this.donviid = crru.id_don_vi;
      this.namketoan = crru.nam_ke_toan;
      this.username = crru.user_name;
    }

    this.repo.postRequest('api/taikhoan/dstaikhoanv2', { NamKeToan: this.namketoan, DonViId: this.donviid, UserName: this.username })
            .subscribe(response => {               
                this.inputtaikhoans = response;
            });
      this.LoadCategory();
    this.repo.postRequest('api/cauhinhdongthoi/dscauhinhdongthoi', { DonViId: this.donviid, NamKeToan: this.namketoan })
      .subscribe(response => {

        this.hachtoandongthois = response;
      });
  }
  DongThoiClick1() {
    this.DongThoiClick();
    this.chungtuSelect.DongThois = this.chitietdongthois;
    this.selectedTab(3);
    this.tongtien2 = 0;
    this.chungtuSelect.DongThois.forEach(
      (item) => {
        this.tongtien2 = this.tongtien2 + (item.So_Tien === null ? 0 : item.So_Tien);
      }
    );
    if (this.chungtuSelect.ChiTiets.length <= 50) {
      (window as any).timer01(this.fixcot, 1500, 'fixTablechungtukhac_03');
    }
  }
  DongThoiClick() {
    this.chitietdongthois = [];
    this.chungtuSelect.ChiTiets.forEach(
      (row) => {
        this.hachtoandongthois.forEach(
          (item) => {
            if (
              item.Hinh_Thuc_Cap_Phat_Id === row.Hinh_Thuc_Cap_Phat_Id && item.Nghiep_Vu_Id === row.Nghiep_Vu_Id && (item.Nguon_Id === null || item.Nguon_Id === row.Nguon_Id || (item.Ma_Nguon !== null && item.Ma_Nguon.indexOf(row.Nguon_Id) > -1))
              && row.Tai_Khoan_Co_Id !== null && row.Tai_Khoan_No_Id !== null
              && item.Tai_Khoan_Co !== null
              && item.Tai_Khoan_No !== null
              && item.Tai_Khoan_Co.indexOf(row.Tai_Khoan_Co_Id) > -1 && item.Tai_Khoan_No.indexOf(row.Tai_Khoan_No_Id) > -1
              && row.So_Tien !== null && row.So_Tien!==0
            ) {
              this.AddRowDongThoi(row, item);
            }
          }
        );
      }
    );
    console.log(this.hachtoandongthois);
  }
  AddRowDongThoi(row: any, item: any) {
    let sotien = 0;
    var sp = 'bottom';
    if (this.chungtuSelect.DongThois.length > 9)
      sp = 'top'
    item.ChiTiets.forEach(
      (it) => {
        sotien = row.So_Tien;
        if (it.Am_Duong == 2 || it.Am_Duong == '2')
          sotien = row.So_Tien * -1;
        this.chitietdongthois.push({
          showpopup: sp, Tai_Khoan_No_Id: it.Tai_Khoan_No_Id, Tai_Khoan_Co_Id: it.Tai_Khoan_Co_Id, SoCTG: row.SoCTG, NgayCTG: row.NgayCTG, Dien_Giai_Chi_Tiet: row.Dien_Giai_Chi_Tiet, So_Tien: sotien,
          Nguon_Id: row.Nguon_Id, Chuong_Id: row.Chuong_Id, Loai_Khoan_Id: row.Loai_Khoan_Id, Tieu_Muc_Id: row.Tieu_Muc_Id, Hinh_Thuc_Cap_Phat_Id: it.Hinh_Thuc_Cap_Phat_Id, Nghiep_Vu_Id: it.Nghiep_Vu_Id,
          Ngan_Hang_Id: row.Ngan_Hang_Id, Ma_Thong_Ke_Id: row.Ma_Thong_Ke_Id, CTMT_Id: row.CTMT_Id, Hoat_Dong_Id: row.Hoat_Dong_Id, Doi_Tuong_Id: row.Doi_Tuong_Id, Doi_Tuong_Id2: row.Doi_Tuong_Id2, Doi_Tuong_Id_5: row.Doi_Tuong_Id_5, Doi_Tuong_Id_4: row.Doi_Tuong_Id_4
        });
      }
    );


    this.tabselected = 3;
  } 
  inputdinhkhoanmaus: any;
  dinhkhoanmau(row: any) {
    console.log(row);

    this.repo.postRequest("api/chungtu/get_chitietdinhkhoanmau/", { id: row.Id })
      .subscribe(response => {
        if (this.chungtuSelect.ChiTiets != null && this.chungtuSelect.ChiTiets.length > 0) {
          if (this.chungtuSelect.ChiTiets.length == 1 && (this.chungtuSelect.ChiTiets[0].So_Tien == null || this.chungtuSelect.ChiTiets[0].So_Tien == 0))
            this.chungtuSelect.ChiTiets = response;
          else
          this.chungtuSelect.ChiTiets = this.chungtuSelect.ChiTiets.concat(response);
        }
        else
          this.chungtuSelect.ChiTiets = response;

      });
  }
  LoadCategory(): void {
    //---------------load phân hệ-------------------------------------------
    this.repo.postRequest('api/chungtu/dinhkhoanmaus', { Id: null, Chuoi: this.donviid, Nam: this.namketoan })
      .subscribe(response => {
        this.inputdinhkhoanmaus = response;
      });
    //------------------------------------------------------------------------
    this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: Lists_doituongtaphop.id, MaGiaoDien: '', DonViId: this.donviid })
      .subscribe(response => {
        this.inputtaphops = response;
      });
    this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: Lists_taisancodinh.id, MaGiaoDien: '4', DonViId: this.donviid, NamKeToan: this.namketoan })
      .subscribe(response => {
        this.inputtaisans = response;
      });
    this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: Lists_doituongtaphop2.id, MaGiaoDien: '', DonViId: this.donviid })
      .subscribe(response => {
        this.inputtaphops2 = response;
      });
    this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: Lists_hoatdong.id, MaGiaoDien: '', DonViId: this.donviid })
      .subscribe(response => {
        this.inputhoatdongs = response;
      });
    this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: Lists_cmmt.id, MaGiaoDien: '', DonViId: this.donviid })
      .subscribe(response => {
        this.inputcmmts = response;
      });
    this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: Lists_mathongke.id, MaGiaoDien: '', DonViId: this.donviid })
      .subscribe(response => {
        this.inputthongkes = response;
      });
    this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: Lists_caphat.id, MaGiaoDien: '', DonViId: this.donviid })
        .subscribe(response => {
          this.inputcaphats = response;
      });
    this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: Lists_nghiepvu.id, MaGiaoDien: '', DonViId: this.donviid })
        .subscribe(response => {
          this.inputnghiepvus = response;
      });
    this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: Lists_nganhang.id, MaGiaoDien: '', DonViId: this.donviid })
        .subscribe(response => {
          this.inputnganhangs = response;
      });
    this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv21', { NhomId: '532A61EA-D765-844B-8CBF-E610B209E332', MaGiaoDien: '', DonViId: this.donviid, NamKeToan: this.namketoan, UserName: this.username })
            .subscribe(response => {                
                this.inputkhachhangs = response;
            });
            this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2',{NhomId:Lists_nguonkinhphi.id,MaGiaoDien:'',DonViId:this.donviid})
            .subscribe(response => {
                this.inputnguonkinhphis = response;
            });
            this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2',{NhomId:Lists_chuong.id,MaGiaoDien:'',DonViId:this.donviid})
            .subscribe(response => {
                this.inputchuongs = response;
            });
            this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2',{NhomId:Lists_loaikhoan.id,MaGiaoDien:'',DonViId:this.donviid})
            .subscribe(response => {
                this.inputloaikhoans = response;
            });
            this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2',{NhomId:Lists_tieumuc.id,MaGiaoDien:'',DonViId:this.donviid})
            .subscribe(response => {
                this.inputtieumucs = response;
      });
    this.repo.postRequest('api/doituong/dstiente', { DonViId: this.donviid })
      .subscribe(response => {
        this.inputloaitiens = response;
      });
    this.repo.postRequest('api/doituong/getloaithue', { NhomId: null, MaGiaoDien: '', DonViId: this.donviid, NamKeToan: this.namketoan, UserName: this.username, Loai: 0 })
      .subscribe(response => {
        this.inputloaithues = response;
      });


    }
    
    @ViewChildren("myinput") divs: QueryList<ElementRef>;

   
  selectedTab(tab: number) {
    this.tabselected = tab;
    setTimeout(() => {
      this.setComboFocus(0, 1, tab);
    }, 500);
  }
  //----------event xử lý di chuyển Enter--------------------------------------
  setComboFocus(hang: number, cot: number, luoi: number) {
    var tencombo: string = hang + '_' + cot + '_' + luoi;
        var ketqua = false;
        this.slcombo.forEach(
          (question, i, allQuestions) => {
            if (question.labelForId === tencombo)
                {
                    ketqua = true;
                    question.focus();
                }
			}
        );
        
        if(ketqua === false)
        {
            this.divs.forEach(
                (div) => {              
                   
                    if(div.nativeElement.id === tencombo)
                    {
                        ketqua = true;
                        div.nativeElement.focus();
                    }
                 
                }
            );
        }
    }
    keyLyDo(event: any) { 
        if (event.which === 13) {
            //this.slTaiKhoanNo.focus();
          this.setComboFocus(0,1,1);  
            event.preventDefault();
          }
   }
   keyTKNoPress(event: any) { 
    if (event.which === 13) {
        this.setComboFocus(0,1,1);  
        event.preventDefault();
      }
    }
   maxcot:number = 14;
  
   keyComBoPress(event: any,hang:number, cot:number, luoi: number) {            

     if (luoi === 4)
       this.maxcot = 11;

       if (luoi === 2)
       this.maxcot = 9;
     if (luoi === 1)
       this.maxcot = 20;
     if (luoi === 3)
       this.maxcot = 18;
        if (event.which === 13) {           
            cot= cot + 1;
            
            if(cot > this.maxcot)
            {
                hang = hang +1;  
                cot = 1;
                
              if (luoi === 3) {
                if (hang === this.chungtuSelect.DongThois.length) {
                  this.AddRowNew(this.chungtuSelect.DongThois);
                  if (this.chungtuSelect.DongThois.length <= 50) {
                    (window as any).timer01(this.fixcot, 1500, 'fixTablechungtukhac_02');
                  }
                  setTimeout(() => {
                    this.setComboFocus(hang, cot, luoi);
                    event.preventDefault();
                  }, 1500);
                }
              }
              else if (luoi === 4) {
                if (hang === this.chungtuSelect.HoaDons.length) {
                  this.AddRowNewHD(this.chungtuSelect.HoaDons);
                  if (this.chungtuSelect.HoaDons.length <= 50) {
                    (window as any).timer01(this.fixcot, 1500, 'fixTablechungtukhac_04');
                  }
                  setTimeout(() => {
                    this.setComboFocus(hang, cot, luoi);
                    event.preventDefault();
                  }, 1500);
                }
              }
              else {
                if (hang === this.chungtuSelect.ChiTiets.length) {
                  this.AddRowNew(this.chungtuSelect.ChiTiets);
                  if (this.chungtuSelect.ChiTiets.length <= 50) {
                    (window as any).timer01(this.fixcot, 1500, 'fixTablechungtukhac_01');
                    (window as any).timer01(this.fixcot, 1500, 'fixTablechungtukhac_02');
                  }
                  setTimeout(() => {
                    this.setComboFocus(hang, cot, luoi);
                    event.preventDefault();
                  }, 1500);
                }
              }
          }
          this.setComboFocus(hang,cot, luoi);            
            event.preventDefault();
        }
  }
  RowNewClick() {
    if (this.tabselected === 3) {
      this.AddRowNew(this.chungtuSelect.DongThois);
      if (this.chungtuSelect.ChiTiets.length <= 50) {
        (window as any).timer01(this.fixcot, 1500, 'fixTablechungtukhac_03');
      }
    }
    else if (this.tabselected === 4)
    {
      this.AddRowNewHD(this.chungtuSelect.HoaDons);
      if (this.chungtuSelect.HoaDons.length <= 50) {
        (window as any).timer01(this.fixcot, 1500, 'fixTablechungtukhac_04');
      }
    }
    else {
      this.AddRowNew(this.chungtuSelect.ChiTiets);
      if (this.chungtuSelect.ChiTiets.length <= 50) {
        (window as any).timer01(this.fixcot, 1500, 'fixTablechungtukhac_01');
         (window as any).timer01(this.fixcot, 1500, 'fixTablechungtukhac_02');
      }
    }
  }
  AddRowKep(index: string, luoi: number) {
    var row = this.chungtuSelect.ChiTiets[index];
    var sp = 'bottom';
    if (this.chungtuSelect.DongThois.length > 9)
      sp = 'top'
    this.chungtuSelect.DongThois.push({
      showpopup: sp, Tai_Khoan_No_Id: null, Tai_Khoan_Co_Id: null, SoCTG: row.SoCTG, NgayCTG: row.NgayCTG, Dien_Giai_Chi_Tiet: row.Dien_Giai_Chi_Tiet, So_Tien: row.So_Tien,
      Nguon_Id: row.Nguon_Id, Chuong_Id: row.Chuong_Id, Loai_Khoan_Id: row.Loai_Khoan_Id, Tieu_Muc_Id: row.Tieu_Muc_Id, Hinh_Thuc_Cap_Phat_Id: row.Hinh_Thuc_Cap_Phat_Id, Nghiep_Vu_Id: row.Nghiep_Vu_Id,
      Ngan_Hang_Id: row.Ngan_Hang_Id, Ma_Thong_Ke_Id: row.Ma_Thong_Ke_Id, CTMT_Id: row.CTMT_Id, Hoat_Dong_Id: row.Hoat_Dong_Id, Doi_Tuong_Id2: null, Doi_Tuong_Id: null, Doi_Tuong_Id_5: null, Doi_Tuong_Id_4: null
    });
    this.tabselected = 3;
  }
  AddRowNew(ctiets: any) {
    var sp = 'bottom';
    if (ctiets.length > 9)
      sp = 'top'
    if (ctiets.length > 0) //trường hợp lớn hơn 1 thì copy dòng cuối
    {
      var row = ctiets[ctiets.length - 1];

      ctiets.push({
        showpopup: sp, Tai_Khoan_No_Id: row.Tai_Khoan_No_Id, Tai_Khoan_Co_Id: row.Tai_Khoan_Co_Id, SoCTG: row.SoCTG, NgayCTG: row.NgayCTG, Dien_Giai_Chi_Tiet: row.Dien_Giai_Chi_Tiet                                             , So_Tien: null,
        Nguon_Id: row.Nguon_Id, Chuong_Id: row.Chuong_Id, Loai_Khoan_Id: row.Loai_Khoan_Id, Tieu_Muc_Id: row.Tieu_Muc_Id, Hinh_Thuc_Cap_Phat_Id: row.Hinh_Thuc_Cap_Phat_Id, Nghiep_Vu_Id: row.Nghiep_Vu_Id,
        Ngan_Hang_Id: row.Ngan_Hang_Id, Ma_Thong_Ke_Id: row.Ma_Thong_Ke_Id, CTMT_Id: row.CTMT_Id, Hoat_Dong_Id: row.Hoat_Dong_Id, Doi_Tuong_Id2: row.Doi_Tuong_Id2, Doi_Tuong_Id: row.Doi_Tuong_Id, Doi_Tuong_Id_5: row.Doi_Tuong_Id_5, Doi_Tuong_Id_4: row.Doi_Tuong_Id_4
      });
    }
    else
    {
      ctiets.push({
        showpopup: sp, Tai_Khoan_No_Id: null, Tai_Khoan_Co_Id: null, SoCTG: null, NgayCTG: null, Dien_Giai_Chi_Tiet: null, So_Tien: null,
        Nguon_Id: null, Chuong_Id: null, Loai_Khoan_Id: null, Tieu_Muc_Id: null, Hinh_Thuc_Cap_Phat_Id: null, Nghiep_Vu_Id: null,
        Ngan_Hang_Id: null, Ma_Thong_Ke_Id: null, CTMT_Id: null, Hoat_Dong_Id: null, Doi_Tuong_Id: null, Doi_Tuong_Id2: null, Doi_Tuong_Id_5: null, Doi_Tuong_Id_4: null
      });

    }
    
  }
  AddRowNewHD(ctiets: any) {
    var sp = 'bottom';
    if (ctiets.length > 9)
      sp = 'top'
    if (ctiets.length > 0) //trường hợp lớn hơn 1 thì copy dòng cuối
    {
      var row = ctiets[ctiets.length - 1];




      ctiets.push({
        showpopup: sp, Id: null, Chung_Tu_Id: row.Chung_Tu_Id, Loai_Thue_Id: row.Loai_Thue_Id
        , Ngay_Hoa_Don: row.Ngay_Hoa_Don, So_Hoa_Don: row.So_Hoa_Don
        , So_Hieu: row.So_Hieu, Thue_Suat: row.Thue_Suat
        , Tien_Thue: row.Tien_Thue, Tien_Hang: row.Tien_Hang, Ma_So_Thue: null
        , Doi_Tuong: null, Dien_Giai: row.Dien_Giai, Ke_Khai: row.Ke_Khai,
        Remove_Hoa_Don: null, DoanhNghiepId: null, TransactionID: null, Created: null, CreatedBy: null, Modified: null, ModifiedBy: null

      });
    }
    else {
      ctiets.push({
        showpopup: sp, Id: null, Chung_Tu_Id: null, Loai_Thue_Id: null
        , Ngay_Hoa_Don: null, So_Hoa_Don: null
        , So_Hieu: null, Thue_Suat: null

        , Tien_Thue: null, Tien_Hang: null, Ma_So_Thue: null
        , Doi_Tuong: null, Dien_Giai: null, Ke_Khai: null,
        Remove_Hoa_Don: null, DoanhNghiepId: null, TransactionID: null, Created: null, CreatedBy: null, Modified: null, ModifiedBy: null


      });

    }

    //this.chungtuSelect.HoaDons = ctiets;

  }
    //----------event các control------------------------------------------------------
  onLienQuanChange($event) {

    console.log($event)
    if (typeof $event !== "undefined") {
      this.repo.postRequest("api/chungtu/get_thongtinrutdutoan/", { id: $event.Id })
        .subscribe(response => {
          console.log(response);
          response.Ma_Chung_Tu = this.chungtuSelect.Ma_Chung_Tu;
          response.Lien_Quan_Id = response.Id;
          this.chungtuSelect = response;
          this.chungtuSelect.Id = null;
          this.chungtuSelect.Phan_He_Id = this.phanheid;
          this.ngaychungtu = new Date(this.chungtuSelect.Ngay_Chung_Tu);
          this.ngayghiso = new Date(this.chungtuSelect.Ngay_Ghi_So);

        });
    }
  }
    onDoiTuongChange($event) {
      
        if( typeof $event === "undefined")
        {
          this.chungtuSelect.Ho_Ten = null;
          //item.Doi_Tuong = null;
          //item.Doi_Tuong2 = null;
        }
        else 
        {
          this.chungtuSelect.Ho_Ten = $event.Ten_Doi_Tuong;
          // chỉ gán đối tượng cho chứng từ khác chứng từ kết chuyển
          if (this.lachungtuketchuyen == false) {
            this.chungtuSelect.ChiTiets.forEach(
              (item) => {
                //if (item.Doi_Tuong_Id === null)
                item.Doi_Tuong_Id = $event.Id;
                //if (item.Doi_Tuong_Id2 === null)
                item.Doi_Tuong_Id2 = $event.Id;

                item.Doi_Tuong = $event.Ten_Doi_Tuong;
                item.Doi_Tuong2 = $event.Ten_Doi_Tuong;
              }
            );
          }

          this.repo.getRequest("api/baselayout/ThongTinDiaChi/" + $event.Id)
            .subscribe(response => {
              //console.log(response);
              this.chungtuSelect.Dia_Chi = response.Dia_Chi;

            });
        }
    }
    onTaiNoChange($event) {
        if( typeof $event === "undefined")
        {
            this.taikhoanno=null;
        }
        else
        this.taikhoanno = $event.Ten_Tai_Khoan;
  }
  onTaiSanChange($event, hang: number) {
    var rs = this.chungtuSelect.ChiTiets[hang];

    if (typeof $event === "undefined") {
      rs.Dien_Giai_Chi_Tiet = null;
    }
    else {
      rs.Dien_Giai_Chi_Tiet = $event.Ten_Doi_Tuong;
      rs.Tai_Khoan_No_Id = $event.TK_Tai_San_Id;
      // rs.Chuong_Id = $event.Chuong_Id;
      rs.Loai_Khoan_Id = $event.Loai_Khoan_Id;
      rs.Tieu_Muc_Id = $event.Tieu_Muc_Id;
      rs.So_Tien = $event.Nguyen_Gia;
      if ($event != "undefined" && $event.Nguon_Id != null && $event.Nguon_Id != "undefined")
        rs.Nguon_Id = $event.Nguon_Id;
    }

  }
    comboSearchFn(term: string, item: any) {
        term = term.toLowerCase();
        return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
  }
  comboSearchFnTKS(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ma_Tai_Khoan.toLowerCase().startsWith(term);
  }
    rowSelected: any = null;
  comboSeleted: NgSelectComponent;
  cotSelected: number;

    AddDoiTuong(cobo:NgSelectComponent,hang:number,cot:number)
    {
       
      this.comboSeleted = cobo;
      this.cotSelected = cot;
        console.log(cobo)
        
        cobo.close();
      this.rowSelected = this.chungtuSelect.ChiTiets[hang];
      if (cobo.addTagText.toLowerCase() === Lists_nganhang.id.toLowerCase()) {
        this.nganhangedit.loadDataInit(cobo.addTagText, null, this.donviid, cot);
        this.mdDoiTuongNH.open();
      }
      else
      {
        if (cobo.addTagText.toLowerCase() === this.doituongid.toLowerCase()) {
          this.AddNguoiNop2(cobo);
        }
        else if (cobo.addTagText.toLowerCase() === Lists_taisancodinh.id.toLowerCase()) {
          this.taisanedit.loadDataInit(cobo.addTagText, null, this.donviid, cot);
          this.mdTaiSan.open();
        }
        else 
          {
            this.doituongchungedit.loadDataInit(cobo.addTagText, null, this.donviid);
            this.mdDoiTuongChung.open();
          }
      }
      
        
  }
  AddNguoiNop2(cobo: NgSelectComponent) {
    this.comboSeleted = cobo;
    this.themdoituongtrenluoi = 1;
    cobo.close();
    this.mdLuaChon.open();
    
  }
    AddNguoiNop(cobo:NgSelectComponent)
    {
        this.themdoituongtrenluoi = 0;
        this.comboSeleted = cobo;
        cobo.close();
        this.mdLuaChon.open();
    }
    loaithem:number = 2;
    onLoaiNguoiNop(loai:number)
    {
        this.loaithem = loai;
        console.log(loai);
    }
    AddFormNguoiNop(){
        this.mdLuaChon.dismiss();
        if(this.loaithem === 2)
        {
            this.canboedit.loadDataInit(Lists_canbo.id, null,this.donviid);
            this.mdCanBo.open();
        }
        else if (this.loaithem === 3) {
          this.khachhangedit.loadDataInit(Lists_khachhang.id, null, this.donviid);
          this.mdKhachhang.open();
        }
        else 
        {
          this.khachhangedit.loadDataInit(Lists_nhacungcap.id, null,this.donviid);
            this.mdKhachhang.open();
        }
    }

    //------------------------------------
  saveModalTaiSan(doituong: any) {
    this.mdTaiSan.dismiss();
    if (doituong != null) {
      console.log(doituong);
      this.inputtaisans.push({ Id: doituong.Id, Ma_Doi_Tuong: doituong.Ma_Doi_Tuong, Ten_Doi_Tuong: doituong.Ten_Doi_Tuong, TK_Tai_San_Id: doituong.TK_Tai_San_Id, Nguon_Id: doituong.Nguon_Id, Loai_Khoan_Id: doituong.Loai_Khoan_Id, Tieu_Muc_Id: doituong.Tieu_Muc_Id })
      this.inputtaisans = this.inputtaisans.slice();

      this.rowSelected.Tai_San_Id = doituong.Id;
      this.rowSelected.Dien_Giai_Chi_Tiet = doituong.Ten_Doi_Tuong;
      this.rowSelected.Tai_Khoan_No_Id = doituong.TK_Tai_San_Id;
      this.rowSelected.Nguon_Id = doituong.Nguon_Id;
      this.rowSelected.Loai_Khoan_Id = doituong.Loai_Khoan_Id;
      this.rowSelected.Tieu_Muc_Id = doituong.Tieu_Muc_Id;
    }
  }

  saveModalKhacHang(doituong: any) {
    this.mdKhachhang.dismiss();

    this.inputkhachhangs.push({ Id: doituong.Id, Ma_Doi_Tuong: doituong.Ma_Doi_Tuong, Ten_Doi_Tuong: doituong.Ten_Doi_Tuong })
    this.inputkhachhangs = this.inputkhachhangs.slice();
    if (this.cotSelected===7)
      this.rowSelected.Doi_Tuong_Id = doituong.Id;
    if (this.cotSelected === 8)
      this.rowSelected.Doi_Tuong_Id2 = doituong.Id; 

    if (this.themdoituongtrenluoi === 0) {
      this.chungtuSelect.Doi_Tuong_Id = doituong.Id;
      this.tendoituong = doituong.Ten_Doi_Tuong;
    }
  }
  saveModalCanBo(doituong: any) {    
      this.mdCanBo.dismiss();
    this.inputkhachhangs.push({ Id: doituong.Id, Ma_Doi_Tuong: doituong.Ma_Doi_Tuong, Ten_Doi_Tuong: doituong.Ten_Doi_Tuong })
    this.inputkhachhangs = this.inputkhachhangs.slice();
    if (this.cotSelected === 7)
      this.rowSelected.Doi_Tuong_Id = doituong.Id;
    if (this.cotSelected === 8)
      this.rowSelected.Doi_Tuong_Id2 = doituong.Id; 
    if (this.themdoituongtrenluoi === 0) {
      this.chungtuSelect.Doi_Tuong_Id = doituong.Id;
      this.tendoituong = doituong.Ten_Doi_Tuong;
    }
  }
  saveModalNganHang(doituong: any) {
    this.mdDoiTuongNH.dismiss();
    this.inputnganhangs.push({ Id: doituong.Id, Ma_Doi_Tuong: doituong.Ma_Doi_Tuong, Ten_Doi_Tuong: doituong.Ten_Doi_Tuong })
    this.inputnganhangs = this.inputnganhangs.slice();

    this.rowSelected.Ngan_Hang_Id = doituong.Id;   
  }
    
    saveModal(doituong:any){        
        console.log(doituong);        
      this.mdDoiTuongChung.dismiss();
      if (doituong != null && Lists_doituongtaphop.id === doituong.Nhom_Doi_Tuong_ID) {
        this.inputtaphops.push({ Id: doituong.Id, Ma_Doi_Tuong: doituong.Ma_Doi_Tuong, Ten_Doi_Tuong: doituong.Ten_Doi_Tuong })
        this.inputtaphops = this.inputtaphops.slice();

        this.rowSelected.Doi_Tuong_Id_5 = doituong.Id;
      }
      if (doituong != null && Lists_doituongtaphop2.id === doituong.Nhom_Doi_Tuong_ID) {

        this.inputtaphops2.push({ Id: doituong.Id, Ma_Doi_Tuong: doituong.Ma_Doi_Tuong, Ten_Doi_Tuong: doituong.Ten_Doi_Tuong })
        this.inputtaphops2 = this.inputtaphops2.slice();
        this.rowSelected.Doi_Tuong_Id_4 = doituong.Id;
      }
      if (doituong != null && Lists_hoatdong.id === doituong.Nhom_Doi_Tuong_ID) {
        
        this.inputhoatdongs.push({ Id: doituong.Id, Ma_Doi_Tuong: doituong.Ma_Doi_Tuong, Ten_Doi_Tuong: doituong.Ten_Doi_Tuong })
        this.inputhoatdongs = this.inputhoatdongs.slice();
        this.rowSelected.Hoat_Dong_Id = doituong.Id;
      }
      if (doituong != null && Lists_cmmt.id === doituong.Nhom_Doi_Tuong_ID) {
       
        this.inputcmmts.push({ Id: doituong.Id, Ma_Doi_Tuong: doituong.Ma_Doi_Tuong, Ten_Doi_Tuong: doituong.Ten_Doi_Tuong })
        this.inputcmmts = this.inputcmmts.slice();
        this.rowSelected.CTMT_Id = doituong.Id;
      }
      if (doituong != null && Lists_mathongke.id === doituong.Nhom_Doi_Tuong_ID) {
        
        this.inputthongkes.push({ Id: doituong.Id, Ma_Doi_Tuong: doituong.Ma_Doi_Tuong, Ten_Doi_Tuong: doituong.Ten_Doi_Tuong })
        this.inputthongkes = this.inputthongkes.slice();
        this.rowSelected.Ma_Thong_Ke_Id = doituong.Id;
      }
      if (doituong != null && Lists_caphat.id === doituong.Nhom_Doi_Tuong_ID) {
        
        this.inputcaphats.push({ Id: doituong.Id, Ma_Doi_Tuong: doituong.Ma_Doi_Tuong, Ten_Doi_Tuong: doituong.Ten_Doi_Tuong })
        this.inputcaphats = this.inputcaphats.slice();       
        this.rowSelected.Hinh_Thuc_Cap_Phat_Id = doituong.Id;
      }
      if (doituong != null && Lists_nghiepvu.id === doituong.Nhom_Doi_Tuong_ID) {
       
        this.inputnghiepvus.push({ Id: doituong.Id, Ma_Doi_Tuong: doituong.Ma_Doi_Tuong, Ten_Doi_Tuong: doituong.Ten_Doi_Tuong })
        this.inputnghiepvus = this.inputnghiepvus.slice();
       
        this.rowSelected.Nghiep_Vu_Id = doituong.Id;
      }
        if(doituong!= null && this.nhomnguonid ===  doituong.Nhom_Doi_Tuong_ID)
        {
         
            this.inputnguonkinhphis.push({Id:doituong.Id,Ma_Doi_Tuong:doituong.Ma_Doi_Tuong,Ten_Doi_Tuong:doituong.Ten_Doi_Tuong})
            this.inputnguonkinhphis =  this.inputnguonkinhphis.slice();
           
            this.rowSelected.Nguon_Id = doituong.Id;
        }
        if(doituong!= null && this.nhomloaikhoanid ===  doituong.Nhom_Doi_Tuong_ID)
        {
           
            this.inputloaikhoans.push({Id:doituong.Id,Ma_Doi_Tuong:doituong.Ma_Doi_Tuong,Ten_Doi_Tuong:doituong.Ten_Doi_Tuong})
            this.inputloaikhoans =  this.inputloaikhoans.slice();            
            this.rowSelected.Loai_Khoan_Id = doituong.Id;
        }
        if(doituong!= null && this.nhomchuongid ===  doituong.Nhom_Doi_Tuong_ID)
        {
         
            this.inputchuongs.push({Id:doituong.Id,Ma_Doi_Tuong:doituong.Ma_Doi_Tuong,Ten_Doi_Tuong:doituong.Ten_Doi_Tuong})
            this.inputchuongs =  this.inputchuongs.slice();            
            this.rowSelected.Chuong_Id = doituong.Id;
        }
        if(doituong!= null && this.nhomtieumucid ===  doituong.Nhom_Doi_Tuong_ID)
        {
          
            this.inputtieumucs.push({Id:doituong.Id,Ma_Doi_Tuong:doituong.Ma_Doi_Tuong,Ten_Doi_Tuong:doituong.Ten_Doi_Tuong})
            this.inputtieumucs =  this.inputtieumucs.slice();            
            this.rowSelected.Tieu_Muc_Id = doituong.Id;
        }
        this.comboSeleted.focus();
  }
  deleterow(index: string, luoi: number) {
    console.log(index);
    swal({
      title: 'Bạn muốn xóa dòng này phải không?',
      text: 'Dữ liệu xóa sẽ không phục hồi lại được!',
      icon: "warning",
      buttons: {
        cancel: {
          text: 'Hủy bỏ',
          value: false,
          visible: true,
        },
        confirm: {
          text: 'Đồng ý',
          value: true,
          visible: true,
          className: "bg-danger",
          closeModal: true
        }
      }
    })
      .then(willDelete => {
        if (willDelete) {
          if (luoi === 3)
            this.chungtuSelect.DongThois.splice(index, 1);
          else if (luoi === 4)
            this.chungtuSelect.HoaDons.splice(index, 1);
          else
            this.chungtuSelect.ChiTiets.splice(index, 1);

          this.changeST(null);
          this.changeST2(null);
        }
      });


  }

  indexdt: number;
  cotdt: string;
  adddatachondoituongchung_luoi(cot: string, index: number) {
   
    this.indexdt = index;
    this.cotdt = cot;
    if (cot == "Nguon_Id") {
      this.dtechondoituongchungedit.loadDataInit(null, Lists_nguonkinhphi.id);
      //this.mBackdrop = setTimeout(() => {
      //  this.haveBackdrop();
      //}, 500);
      this.mdChonDoiTuongChung.open();
    }
    if (cot == "Chuong_Id") {
      this.dtechondoituongchungedit.loadDataInit(null, Lists_chuong.id);
      this.mdChonDoiTuongChung.open();
    }
    if (cot == "Loai_Khoan_Id") {
      this.dtechondoituongchungedit.loadDataInit(null, Lists_loaikhoan.id);
      this.mdChonDoiTuongChung.open();
    }
    if (cot == "Tieu_Muc_Id") {
      this.dtechondoituongchungedit.loadDataInit(null, Lists_tieumuc.id);
      this.mdChonDoiTuongChung.open();
    }
    if (cot == "Hinh_Thuc_Cap_Phat_Id") {
      this.dtechondoituongchungedit.loadDataInit(null, Lists_caphat.id);
      this.mdChonDoiTuongChung.open();
    }
    if (cot == "Nghiep_Vu_Id") {
      this.dtechondoituongchungedit.loadDataInit(null, Lists_nghiepvu.id);
      this.mdChonDoiTuongChung.open();
    }
    if (cot == "Ma_Thong_Ke_Id") {
      this.dtechondoituongchungedit.loadDataInit(null, Lists_mathongke.id);
      this.mdChonDoiTuongChung.open();
    }
    if (cot == "CTMT_Id") {
      this.dtechondoituongchungedit.loadDataInit(null, Lists_cmmt.id);
      this.mdChonDoiTuongChung.open();
    }
    if (cot == "Hoat_Dong_Id") {
      this.dtechondoituongchungedit.loadDataInit(null, Lists_hoatdong.id);
      this.mdChonDoiTuongChung.open();
    }
    if (cot == "Doi_Tuong_Id" || cot == "Doi_Tuong_Id2") {
      this.dtechondoituongchungedit.loadDataInit(null, Lists_doituong.id);
      this.mdChonDoiTuongChung.open();
    }
    if (cot == "Hang_Hoa_Id") {
      this.dtechondoituongchungedit.loadDataInit(null, Lists_vattuhanghoa.id);
      this.mdChonDoiTuongChung.open();
    }
    if (cot == "Kho_Hang_Id") {
      this.dtechondoituongchungedit.loadDataInit(null, Lists_khohang.id);
      this.mdChonDoiTuongChung.open();
    }
    if (cot == "Don_Vi_Tinh_Id") {
      this.dtechondoituongchungedit.loadDataInit(null, Lists_donvitinh.id);
      this.mdChonDoiTuongChung.open();
    }
    if (cot == "Tai_San_Id") {
      this.dtechondoituongchungedit.loadDataInit(null, Lists_taisancodinh.id);
      this.mdChonDoiTuongChung.open();
    }
    if (cot == "Nhom_Muc_Chi_Id") {
      this.dtechondoituongchungedit.loadDataInit(null, Lists_nhommucchi.id);
      this.mdChonDoiTuongChung.open();
    }
    if (cot == "Doi_Tuong_Id_12" || cot =="Doi_Tuong_Id_1") {
      this.dtechondoituongchungedit.loadDataInit(null, Lists_phongban.id);
      this.mdChonDoiTuongChung.open();
    }
    if (cot == "Ngan_Hang_Id2" || cot == "Ngan_Hang_Id") {
      this.dtechondoituongchungedit.loadDataInit(null, Lists_nganhang.id);
      this.mdChonDoiTuongChung.open();
    }
    if (cot == "Doi_Tuong_Id_4") {
      this.dtechondoituongchungedit.loadDataInit(null, Lists_doituongtaphop2.id);
      this.mdChonDoiTuongChung.open();
    }
    if (cot == "Doi_Tuong_Id_5") {
      this.dtechondoituongchungedit.loadDataInit(null, Lists_doituongtaphop.id);
      this.mdChonDoiTuongChung.open();
    }
    if (cot == "Khoan_Muc_Id") {
      this.dtechondoituongchungedit.loadDataInit(null, Lists_nhiemvuchi.id);
      this.mdChonDoiTuongChung.open();
    }


  }
  adddatachondoituongchung(index: number) {
    this.indexdt = -1;
    this.dtechondoituongchungedit.loadDataInit(this.phanheid, Lists_doituong.id);
    //this.mBackdrop = setTimeout(() => {
    //  this.haveBackdrop();
    //}, 500);
    this.mdChonDoiTuongChung.open();

  }
  savedsdoituongchung(doituong: any) {
    //console.log("savedsdoituongchung");
    //console.log(doituong);
    if (this.indexdt == -1) {
      this.mdChonDoiTuongChung.close();
      //if (doituong != null && doituong.length > 0) {
      //  let i = 0;
      //  doituong.forEach(
      //    (item) => {
      //      if (i == 0) {
      //        this.chungtuSelect.Doi_Tuong_Id = item.Id;
      //        this.chungtuSelect.Ma_Doi_Tuong = item.Ma;
      //        this.chungtuSelect.Ho_Ten = item.Ten;
      //        this.repo.postRequest("api/doituong/ThongTinDiaChi", { Id: item.Id })
      //          .subscribe(response => {
      //            if (response != null)
      //              this.chungtuSelect.Dia_Chi = response.Dia_Chi;
      //            this.mdChonDoiTuongChung.close();
      //          });

              
      //      }
      //      i = i + 1;

      //    }
      //  );

      //}
      //else {
        
      //  if (doituong == null) {

      //  }
      //  else {
      //    this.chungtuSelect.Doi_Tuong_Id = null;
      //    this.chungtuSelect.Ma_Doi_Tuong = null;
      //  }
      //  this.mdChonDoiTuongChung.close();
      //}
    }
    else {
      if (doituong != null && doituong.length > 0) {
        let i = 0;
        doituong.forEach(
          (item) => {
            if (i == 0) {
              if (this.chungtuSelect.ChiTiets == null || this.chungtuSelect.ChiTiets == "undefined") {
              }
              else {

                if (this.cotdt == "Chuong_Id") {
                  this.chungtuSelect.ChiTiets[this.indexdt].Chuong_Id = item.Id;
                  this.chungtuSelect.ChiTiets[this.indexdt].Chuong = item.Ma_Doi_Tuong;
                  this.thaydoi = true;
                }
                if (this.cotdt == "Nguon_Id") {
                  this.chungtuSelect.ChiTiets[this.indexdt].Nguon_Id = item.Id;
                  this.chungtuSelect.ChiTiets[this.indexdt].Nguon = item.Ma_Doi_Tuong;
                  this.thaydoi = true;
                }
                if (this.cotdt == "Loai_Khoan_Id") {
                  this.chungtuSelect.ChiTiets[this.indexdt].Loai_Khoan_Id = item.Id;
                  this.chungtuSelect.ChiTiets[this.indexdt].Loai_Khoan = item.Ma_Doi_Tuong;
                  this.thaydoi = true;
                }
                if (this.cotdt == "Tieu_Muc_Id") {
                  this.chungtuSelect.ChiTiets[this.indexdt].Tieu_Muc_Id = item.Id;
                  this.chungtuSelect.ChiTiets[this.indexdt].Tieu_Muc = item.Ma_Doi_Tuong;
                }
                if (this.cotdt == "Hinh_Thuc_Cap_Phat_Id") {
                  this.chungtuSelect.ChiTiets[this.indexdt].Hinh_Thuc_Cap_Phat_Id = item.Id;
                  this.chungtuSelect.ChiTiets[this.indexdt].Hinh_Thuc_Cap_Phat = item.Ten_Doi_Tuong;
                  this.thaydoi = true;
                }
                if (this.cotdt == "Nghiep_Vu_Id") {
                  this.chungtuSelect.ChiTiets[this.indexdt].Nghiep_Vu_Id = item.Id;
                  this.chungtuSelect.ChiTiets[this.indexdt].Nghiep_Vu = item.Ten_Doi_Tuong;
                  this.thaydoi = true;
                }
               if (this.cotdt == "Ma_Thong_Ke_Id") {
                  this.chungtuSelect.ChiTiets[this.indexdt].Ma_Thong_Ke_Id = item.Id;
                 this.chungtuSelect.ChiTiets[this.indexdt].Ma_Thong_Ke = item.Ma_Doi_Tuong;
                 this.thaydoi = true;
                }
                if (this.cotdt == "CTMT_Id") {
                  this.chungtuSelect.ChiTiets[this.indexdt].CTMT_Id = item.Id;
                  this.chungtuSelect.ChiTiets[this.indexdt].CTMT = item.Ma_Doi_Tuong;
                  this.thaydoi = true;
                }
                if (this.cotdt == "Hoat_Dong_Id") {
                  this.chungtuSelect.ChiTiets[this.indexdt].Hoat_Dong_Id = item.Id;
                  this.chungtuSelect.ChiTiets[this.indexdt].Hoat_Dong = item.Ten_Doi_Tuong;
                }
                if (this.cotdt == "Doi_Tuong_Id") {
                  this.chungtuSelect.ChiTiets[this.indexdt].Doi_Tuong_Id = item.Id;
                  this.chungtuSelect.ChiTiets[this.indexdt].Doi_Tuong = item.Ten_Doi_Tuong;
                  this.thaydoi = true;
                }
                if (this.cotdt == "Doi_Tuong_Id2") {
                  this.chungtuSelect.ChiTiets[this.indexdt].Doi_Tuong_Id2 = item.Id;
                  this.chungtuSelect.ChiTiets[this.indexdt].Doi_Tuong2 = item.Ten_Doi_Tuong;
                  this.thaydoi = true;
                }
                if (this.cotdt == "Hang_Hoa_Id") {
                  this.chungtuSelect.ChiTiets[this.indexdt].Hang_Hoa_Id = item.Id;
                  this.chungtuSelect.ChiTiets[this.indexdt].Hang_Hoa = item.Ma_Doi_Tuong;
                }
                if (this.cotdt == "Kho_Hang_Id") {
                  this.chungtuSelect.ChiTiets[this.indexdt].Kho_Hang_Id = item.Id;
                  this.chungtuSelect.ChiTiets[this.indexdt].Kho_Hang = item.Ten_Doi_Tuong;
                }
                if (this.cotdt == "Don_Vi_Tinh_Id") {
                  this.chungtuSelect.ChiTiets[this.indexdt].Don_Vi_Tinh_Id = item.Id;
                  this.chungtuSelect.ChiTiets[this.indexdt].Don_Vi_Tinh = item.Ten_Doi_Tuong;
                }
                if (this.cotdt == "Tai_San_Id") {
                  this.chungtuSelect.ChiTiets[this.indexdt].Tai_San_Id = item.Id;
                  this.chungtuSelect.ChiTiets[this.indexdt].Tai_San = item.Ma_Doi_Tuong;

                  

                }
                if (this.cotdt == "Nhom_Muc_Chi_Id") {
                  this.chungtuSelect.ChiTiets[this.indexdt].Nhom_Muc_Chi_Id = item.Id;
                  this.chungtuSelect.ChiTiets[this.indexdt].Nhom_Muc_Chi = item.Ten_Doi_Tuong;
                }
                if (this.cotdt == "Doi_Tuong_Id_12") {
                  this.chungtuSelect.ChiTiets[this.indexdt].Doi_Tuong_Id_12 = item.Id;
                  this.chungtuSelect.ChiTiets[this.indexdt].Doi_Tuong_12 = item.Ten_Doi_Tuong;
                }
                if (this.cotdt == "Doi_Tuong_Id_1") {
                  this.chungtuSelect.ChiTiets[this.indexdt].Doi_Tuong_Id_1 = item.Id;
                  this.chungtuSelect.ChiTiets[this.indexdt].Doi_Tuong_1 = item.Ten_Doi_Tuong;
                }
                if (this.cotdt == "Ngan_Hang_Id2") {
                  this.chungtuSelect.ChiTiets[this.indexdt].Ngan_Hang_Id2 = item.Id;
                  this.chungtuSelect.ChiTiets[this.indexdt].Ngan_Hang2 = item.Ten_Doi_Tuong;
                }
                if (this.cotdt == "Ngan_Hang_Id") {
                  this.chungtuSelect.ChiTiets[this.indexdt].Ngan_Hang_Id = item.Id;
                  this.chungtuSelect.ChiTiets[this.indexdt].Ngan_Hang = item.Ten_Doi_Tuong;
                }

                if (this.cotdt == "Doi_Tuong_Id_4") {
                  this.chungtuSelect.ChiTiets[this.indexdt].Doi_Tuong_Id_4 = item.Id;
                  this.chungtuSelect.ChiTiets[this.indexdt].Doi_Tuong_4 = item.Ten_Doi_Tuong;
                }
                if (this.cotdt == "Doi_Tuong_Id_5") {
                  this.chungtuSelect.ChiTiets[this.indexdt].Doi_Tuong_Id_5 = item.Id;
                  this.chungtuSelect.ChiTiets[this.indexdt].Doi_Tuong_5 = item.Ten_Doi_Tuong;
                }
                if (this.cotdt == "Khoan_Muc_Id") {
                  this.chungtuSelect.ChiTiets[this.indexdt].Khoan_Muc_Id = item.Id;
                  this.chungtuSelect.ChiTiets[this.indexdt].Khoan_Muc = item.Ten_Doi_Tuong;
                }

                //if (this.cotdt == "Hang_Hoa_Id_No") {
                //  this.chungtuSelect.ChiTiets[this.indexdt].Hang_Hoa_Id_No = item.Id;
                //  this.chungtuSelect.ChiTiets[this.indexdt].Hang_Hoa_No = item.Ma;
                //  this.chungtuSelect.ChiTiets[this.indexdt].Dien_Giai_Chi_Tiet = item.Ten;
                // //xuat kho FIFO
                //var rs = this.chungtuSelect.ChiTiets[this.indexdt];
                //this.layGiaHang(rs);
                //}
                

                this.mdChonDoiTuongChung.close();
              }
            }
            i = i + 1;

          }
        );

      }
      else {
        console.log("savedsdoituongchung else");
        if (doituong == null) {
          this.mdChonDoiTuongChung.close();
        }
        else {
          if (this.cotdt == "Chuong_Id") {
            this.chungtuSelect.ChiTiets[this.indexdt].Chuong_Id = null;
            this.chungtuSelect.ChiTiets[this.indexdt].Chuong = null;
            this.thaydoi = true;
          }
          if (this.cotdt == "Nguon_Id") {
            this.chungtuSelect.ChiTiets[this.indexdt].Nguon_Id = null;
            this.chungtuSelect.ChiTiets[this.indexdt].Nguon = null;
            this.thaydoi = true;
          }
          if (this.cotdt == "Loai_Khoan_Id") {
            this.chungtuSelect.ChiTiets[this.indexdt].Loai_Khoan_Id = null;
            this.chungtuSelect.ChiTiets[this.indexdt].Loai_Khoan = null;
            this.thaydoi = true;
          }
          if (this.cotdt == "Tieu_Muc_Id") {
            this.chungtuSelect.ChiTiets[this.indexdt].Tieu_Muc_Id = null;
            this.chungtuSelect.ChiTiets[this.indexdt].Tieu_Muc = null;
            this.thaydoi = true;
          }
          if (this.cotdt == "Hinh_Thuc_Cap_Phat_Id") {
            this.chungtuSelect.ChiTiets[this.indexdt].Hinh_Thuc_Cap_Phat_Id = null;
            this.chungtuSelect.ChiTiets[this.indexdt].Hinh_Thuc_Cap_Phat = null;
          }
          if (this.cotdt == "Nghiep_Vu_Id") {
            this.chungtuSelect.ChiTiets[this.indexdt].Nghiep_Vu_Id = null;
            this.chungtuSelect.ChiTiets[this.indexdt].Nghiep_Vu = null;
            this.thaydoi = true;
          }
          if (this.cotdt == "Ma_Thong_Ke_Id") {
            this.chungtuSelect.ChiTiets[this.indexdt].Ma_Thong_Ke_Id = null;
            this.chungtuSelect.ChiTiets[this.indexdt].Ma_Thong_Ke = null;
            this.thaydoi = true;
          }
          if (this.cotdt == "CTMT_Id") {
            this.chungtuSelect.ChiTiets[this.indexdt].CTMT_Id = null;
            this.chungtuSelect.ChiTiets[this.indexdt].CTMT = null;
            this.thaydoi = true;
          }
          if (this.cotdt == "Hoat_Dong_Id") {
            this.chungtuSelect.ChiTiets[this.indexdt].Hoat_Dong_Id = null;
            this.chungtuSelect.ChiTiets[this.indexdt].Hoat_Dong = null;
          }
          if (this.cotdt == "Doi_Tuong_Id") {
            this.chungtuSelect.ChiTiets[this.indexdt].Doi_Tuong_Id = null;
            this.chungtuSelect.ChiTiets[this.indexdt].Doi_Tuong = null;
            this.thaydoi = true;
          }
          if (this.cotdt == "Doi_Tuong_Id2") {
            this.chungtuSelect.ChiTiets[this.indexdt].Doi_Tuong_Id2 = null;
            this.chungtuSelect.ChiTiets[this.indexdt].Doi_Tuong2 = null;
            this.thaydoi = true;
          }
          if (this.cotdt == "Hang_Hoa_Id") {
            this.chungtuSelect.ChiTiets[this.indexdt].Hang_Hoa_Id = null;
            this.chungtuSelect.ChiTiets[this.indexdt].Hang_Hoa = null;
          }
          if (this.cotdt == "Kho_Hang_Id") {
            this.chungtuSelect.ChiTiets[this.indexdt].Kho_Hang_Id = null;
            this.chungtuSelect.ChiTiets[this.indexdt].Kho_Hang = null;
          }
          if (this.cotdt == "Don_Vi_Tinh_Id") {
            this.chungtuSelect.ChiTiets[this.indexdt].Don_Vi_Tinh_Id = null;
            this.chungtuSelect.ChiTiets[this.indexdt].Don_Vi_Tinh = null;
          }
          if (this.cotdt == "Tai_San_Id") {
            this.chungtuSelect.ChiTiets[this.indexdt].Tai_San_Id = null;
            this.chungtuSelect.ChiTiets[this.indexdt].Tai_San = null;
          }
          if (this.cotdt == "Nhom_Muc_Chi_Id") {
            this.chungtuSelect.ChiTiets[this.indexdt].Nhom_Muc_Chi_Id = null;
            this.chungtuSelect.ChiTiets[this.indexdt].Nhom_Muc_Chi = null;
          }
          if (this.cotdt == "Doi_Tuong_Id_12") {
            this.chungtuSelect.ChiTiets[this.indexdt].Doi_Tuong_Id_12 = null;
            this.chungtuSelect.ChiTiets[this.indexdt].Doi_Tuong_12 = null;
          }
          if (this.cotdt == "Doi_Tuong_Id_1") {
            this.chungtuSelect.ChiTiets[this.indexdt].Doi_Tuong_Id_1 = null;
            this.chungtuSelect.ChiTiets[this.indexdt].Doi_Tuong_1 = null;
          }
          if (this.cotdt == "Ngan_Hang_Id2") {
            this.chungtuSelect.ChiTiets[this.indexdt].Ngan_Hang_Id2 = null;
            this.chungtuSelect.ChiTiets[this.indexdt].Ngan_Hang2 = null;
          }
          if (this.cotdt == "Ngan_Hang_Id") {
            this.chungtuSelect.ChiTiets[this.indexdt].Ngan_Hang_Id = null;
            this.chungtuSelect.ChiTiets[this.indexdt].Ngan_Hang = null;
          }


          if (this.cotdt == "Doi_Tuong_Id_4") {
            this.chungtuSelect.ChiTiets[this.indexdt].Doi_Tuong_Id_4 = null;
            this.chungtuSelect.ChiTiets[this.indexdt].Doi_Tuong_4 = null;
          }
          if (this.cotdt == "Doi_Tuong_Id_5") {
            this.chungtuSelect.ChiTiets[this.indexdt].Doi_Tuong_Id_5 = null;
            this.chungtuSelect.ChiTiets[this.indexdt].Doi_Tuong_5 = null;
          }
          if (this.cotdt == "Khoan_Muc_Id") {
            this.chungtuSelect.ChiTiets[this.indexdt].Khoan_Muc_Id = null;
            this.chungtuSelect.ChiTiets[this.indexdt].Khoan_Muc = null;
          }


        }
        this.mdChonDoiTuongChung.close();
      }
    }
  }


  public savectu(loai: number) {

    if (loai === 0)
      this.chungtuSelect.CapNhatLaiGiayRut = 0;
    else
      this.chungtuSelect.CapNhatLaiGiayRut = 1;

    //if (this.namketoan !== this.ngayghiso.getFullYear()) {
    //  swal('Cảnh báo!', "Ngày hạch toán nằm ngoài năm kế toán!!!", 'warning');
    //  return;
    //}
    if (this.chungtuSelect.Dien_Giai === null || this.chungtuSelect.Dien_Giai === '') {
      swal('Cảnh báo!', "Bạn chưa nhập diễn giải", 'warning');
      return;
    }

    for (let i = 0; i < this.chungtuSelect.ChiTiets.length; i++) {
      var row = this.chungtuSelect.ChiTiets[i];
      if (!this.datecheck(row.NgayCTG))
      {
        swal('Cảnh báo!', "Ngày chứng từ gốc không hợp lệ", 'warning');
        this.setComboFocus(i, 4, 1);
        return;
      }
    }

    if (this.namketoan !== this.ngayghiso.getFullYear()) {
      //swal('Cảnh báo!', "Ngày hạch toán nằm ngoài năm kế toán!!!", 'warning');
      //return;
      swal({
        title: 'Ngày hạch toán nằm ngoài năm kế toán. Bạn muốn tiếp tục lưu không?',
        text: 'Dữ liệu sẽ được lưu vào năm ' + this.ngayghiso.getFullYear().toString() + '. Vui lòng chọn năm ' + this.ngayghiso.getFullYear().toString() + ' sau khi lưu để nhìn thấy chứng từ',
        icon: "warning",
        buttons: {
          cancel: {
            text: 'Hủy bỏ',
            value: false,
            visible: true,
          },
          confirm: {
            text: 'Đồng ý',
            value: true,
            visible: true,
            className: "bg-danger",
            closeModal: true
          }
        }
      })
        .then(willDelete => {
          if (willDelete) {

            /// bắt đầu
            this.chungtuSelect.Ngay_Ghi_So_S = this.ngayghiso.getDate() + '/' + (this.ngayghiso.getMonth() + 1) + '/' + this.ngayghiso.getFullYear();
            this.chungtuSelect.Ngay_Chung_Tu_S = this.ngaychungtu.getDate() + '/' + (this.ngaychungtu.getMonth() + 1) + '/' + this.ngaychungtu.getFullYear();

            if (this.chitietdongthois.length == 0)
              this.DongThoiClick();
            //if (this.chungtuSelect.DongThois.length <= 0 && this.chitietdongthois.length > 0) {
            if ((this.chungtuSelect.DongThois.length <= 0 || this.thaydoi == true) && this.chitietdongthois.length > 0) {
              this.thaydoi = false;
              swal({
                title: 'Bạn có muốn sinh tự động bút toán đồng thời không?',
                text: 'Bút toán đồng thời được sinh tự động dựa trên cấu hình!',
                icon: "warning",
                buttons: {
                  cancel: {
                    text: 'Hủy bỏ',
                    value: false,
                    visible: true,
                  },
                  confirm: {
                    text: 'Đồng ý',
                    value: true,
                    visible: true,
                    className: "bg-danger",
                    closeModal: true
                  }
                }
              })
                .then(willDelete => {
                  if (willDelete) {
                    this.chungtuSelect.DongThois = this.chitietdongthois;
                  }
                  else {
                    $('#loading').show();
                    this.repo.postRequest("api/chungtu/addorupdate_ctuv2", this.chungtuSelect)
                      .subscribe(response => {
                        console.log(response);
                        $('#loading').hide();
                        this.chungtuSelect.Id = response.Data.Id;
                        this.chungtuSelect.ChiTiets = response.Data.ChiTiets;
                        if (response.Status === "OK")
                          this.save.emit(this.chungtuSelect);
                        else
                          swal('Cảnh báo!', response.Status, 'warning');
                      });
                  }

                });
              return;
            }
            $('#loading').show();
            this.repo.postRequest("api/chungtu/addorupdate_ctuv2", this.chungtuSelect)
              .subscribe(response => {
                console.log(response);
                $('#loading').hide();
                if (response.Status === "OK") {
                  this.chungtuSelect.Id = response.Data.Id;
                  this.chungtuSelect.ChiTiets = response.Data.ChiTiets;
                  this.save.emit(this.chungtuSelect);
                }
                else
                  swal('Cảnh báo!', response.Status, 'warning');
              });
            // kết thúc

          }
        });
    } else {
      /// bắt đầu
      this.chungtuSelect.Ngay_Ghi_So_S = this.ngayghiso.getDate() + '/' + (this.ngayghiso.getMonth() + 1) + '/' + this.ngayghiso.getFullYear();
      this.chungtuSelect.Ngay_Chung_Tu_S = this.ngaychungtu.getDate() + '/' + (this.ngaychungtu.getMonth() + 1) + '/' + this.ngaychungtu.getFullYear();

      if (this.chitietdongthois.length == 0)
        this.DongThoiClick();
      //if (this.chungtuSelect.DongThois.length <= 0 && this.chitietdongthois.length > 0) {
      if ((this.chungtuSelect.DongThois.length <= 0 || this.thaydoi == true) && this.chitietdongthois.length > 0) {
        this.thaydoi = false;
        swal({
          title: 'Bạn có muốn sinh tự động bút toán đồng thời không?',
          text: 'Bút toán đồng thời được sinh tự động dựa trên cấu hình!',
          icon: "warning",
          buttons: {
            cancel: {
              text: 'Hủy bỏ',
              value: false,
              visible: true,
            },
            confirm: {
              text: 'Đồng ý',
              value: true,
              visible: true,
              className: "bg-danger",
              closeModal: true
            }
          }
        })
          .then(willDelete => {
            if (willDelete) {
              this.chungtuSelect.DongThois = this.chitietdongthois;
            }
            else {
              $('#loading').show();
              this.repo.postRequest("api/chungtu/addorupdate_ctuv2", this.chungtuSelect)
                .subscribe(response => {
                  console.log(response);
                  $('#loading').hide();
                  this.chungtuSelect.Id = response.Data.Id;
                  this.chungtuSelect.ChiTiets = response.Data.ChiTiets;
                  if (response.Status === "OK")
                    this.save.emit(this.chungtuSelect);
                  else
                    swal('Cảnh báo!', response.Status, 'warning');
                });
            }

          });
        return;
      }
      $('#loading').show();
      this.repo.postRequest("api/chungtu/addorupdate_ctuv2", this.chungtuSelect)
        .subscribe(response => {
          console.log(response);
          $('#loading').hide();
          if (response.Status === "OK") {
            this.chungtuSelect.Id = response.Data.Id;
            this.chungtuSelect.ChiTiets = response.Data.ChiTiets;
            this.save.emit(this.chungtuSelect);
          }
          else
            swal('Cảnh báo!', response.Status, 'warning');
        });
            // kết thúc
    }

    

  }
  closeModal() {
    this.save.emit(null);
  }
  //-------------ham tiện ích---------------------------------------
  
  public changeLuoi(drow: any) {
    this.thaydoi = true;
    this.repo.postRequest("api/chungtu/hienthikekhaithue", this.chungtuSelect)
      .subscribe(response => {
        if (response == "1" || response == "2") {
          this.hienthikekhai = true;
        }
        else {
          this.hienthikekhai = false;
        }
      });
  }
  tongtien: number = 0;
  public changeST(drow: any) {
    this.thaydoi = true;
    this.chungtuSelect.Tong_Tien = 0;
    this.chungtuSelect.ChiTiets.forEach(
      (item) => {
        console.log(item.So_Tien);
        this.chungtuSelect.Tong_Tien = this.chungtuSelect.Tong_Tien + (item.So_Tien === null ? 0 : item.So_Tien)
      }
    );
  }
  public changeNT(drow: any, index: number) {
    this.chungtuSelect.Tong_Tien = 0;
    drow.So_Tien = (drow.Ngoai_Te != null ? drow.Ngoai_Te : 0) * (drow.Ngoai_Te_Ty_Gia != null ? drow.Ngoai_Te_Ty_Gia : 0);
    this.chungtuSelect.ChiTiets[index].So_Tien = drow.So_Tien;
    this.chungtuSelect.ChiTiets.forEach(
      (item) => {
        console.log(item.So_Tien);
        this.chungtuSelect.Tong_Tien = this.chungtuSelect.Tong_Tien + (item.So_Tien === null ? 0 : item.So_Tien)
      }
    );
  }
  datecheck(conformedValue) {
    if (conformedValue == null || conformedValue === "")
      return true;
    const maxValueMonth = [31, 31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
    const formatOrder = ['yyyy', 'yy', 'mm', 'dd', 'HH', 'MM', 'SS']
    var dateFormat: String = 'dd/mm/yyyy';
    var maxYear: number = 9999
    var minYear: number = 1;
    const dateFormatArray = dateFormat.split(/[^dmyHMS]+/).sort((a, b) => formatOrder.indexOf(a) - formatOrder.indexOf(b))

    const indexesOfPipedChars = []
    const maxValue = { 'dd': 31, 'mm': 12, 'yy': 99, 'yyyy': maxYear, 'HH': 23, 'MM': 59, 'SS': 59 }
    const minValue = { 'dd': 1, 'mm': 1, 'yy': 0, 'yyyy': minYear, 'HH': 0, 'MM': 0, 'SS': 0 }
    const conformedValueArr = conformedValue.split('')

    // Check first digit
    dateFormatArray.forEach((format) => {
      const position = dateFormat.indexOf(format)
      const maxFirstDigit = parseInt(maxValue[format].toString().substr(0, 1), 10)

      if (parseInt(conformedValueArr[position], 10) > maxFirstDigit) {
        conformedValueArr[position + 1] = conformedValueArr[position]
        conformedValueArr[position] = 0
        indexesOfPipedChars.push(position)
      }
    })

    // Check for invalid date
    let month = 0
    const isInvalid = dateFormatArray.some((format) => {
      const position = dateFormat.indexOf(format)
      const length = format.length
      const textValue = conformedValue.substr(position, length).replace(/\D/g, '')
      const value = parseInt(textValue, 10)
      if (format === 'mm') {
        month = value || 0
      }
      const maxValueForFormat = format === 'dd' ? maxValueMonth[month] : maxValue[format]
      if (format === 'yyyy' && (minYear !== 1 || maxYear !== 9999)) {
        const scopedMaxValue = parseInt(maxValue[format].toString().substring(0, textValue.length), 10)
        const scopedMinValue = parseInt(minValue[format].toString().substring(0, textValue.length), 10)
        return value < scopedMinValue || value > scopedMaxValue
      }
      return value > maxValueForFormat || (textValue.length === length && value < minValue[format])
    })

    if (isInvalid) {
      return false
    }

    return true;
  }
  


}
export interface Idata {
    Id: string,  
    Ten: string,
    Dien_Thoai: string,
    Dia_Chi: string,
    Email: string,
    GhiChu:string,
    Created: Date,
    CreatedBy: string,
    Modified: Date,
    ModifiedBy:string
}
